module.exports = __webpack_public_path__ + "img/farming-homepage.349514b9.jpg";